import { Injectable, Output, EventEmitter } from "@angular/core";

import { Observable } from "rxjs";
import { CoreService } from "../../base/core";
import { IRole } from "src/app/interfaces/role";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class RoleService {
  constructor(private coreService: CoreService) {}

  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() hideDeatail: EventEmitter<boolean> = new EventEmitter();

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.role.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  fullList(page: number = 1, pageSize: number = 10, header: HttpHeaders): Observable<any> {
    return this.coreService.get(
      ServiceRoute.role.fullList,
      header,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }


  listByHeader(page: number = 1, pageSize: number = 10, header: HttpHeaders): Observable<any> {
    return this.coreService.get(
      ServiceRoute.role.list,
      header,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.role.getById + id,
      new CommonHttpOption().headers
    );
  }
  add(data: IRole): Observable<any> {
    return this.coreService.post(
      ServiceRoute.role.add,
      data,
      new CommonHttpOption().headers
    );
  }
  edit(data: IRole): Observable<any> {
    return this.coreService.put(
      ServiceRoute.role.edit,
      data,
      new CommonHttpOption().headers
    );
  }
  delete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.role.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  fire() {
    this.change.emit();
  }

  hide() {
    this.hideDeatail.emit();
  }
}
